import { defineStore } from 'pinia'

import { ref, computed } from 'vue'
import { VigoMenuItem } from '@/modules/meny/models/types'
import { useI18n } from 'vue-i18n'

export const useMenyStore = defineStore('menyStore', () => {
  const { t } = useI18n()

  const skrivebordMenuItem = computed<VigoMenuItem>(() => ({
    text: t('meny.skrivebord', 'Skrivebord'),
    icon: 'mdi-home',
    route: '/',
    external: false
  }))
  const ungdommerHeaderMenu = computed<VigoMenuItem>(() => ({
    text: t('meny.ungdommer', 'Ungdommer'),
    icon: 'mdi-view-list',
    route: '/ungdommer',
    external: false
  }))
  const ungdomGrupperHeaderMenu = computed<VigoMenuItem>(() => ({
    text: t('meny.ungdomgrupper', 'Ungdomsgrupper'),
    icon: 'mdi-account-group',
    route: '/ungdomgrupper',
    external: false
  }))
  const notaterHeaderMenu = computed<VigoMenuItem>(() => ({
    text: t('meny.notater', 'Notater'),
    icon: 'mdi-note',
    route: '/notater',
    external: false
  }))
  const oppgaverHeaderMenu = computed<VigoMenuItem>(() => ({
    text: t('meny.oppgaver', 'Oppgaver'),
    icon: 'mdi-format-list-checkbox',
    route: '/oppgaver',
    external: false
  }))
  const profilHeaderMenu = computed<VigoMenuItem>(() => ({
    text: t('meny.profil', 'Profil'),
    icon: 'mdi-account',
    route: '/profil',
    external: false
  }))
  const menus = computed<VigoMenuItem[]>(() => [
    skrivebordMenuItem.value,
    ungdommerHeaderMenu.value,
    ungdomGrupperHeaderMenu.value,
    notaterHeaderMenu.value,
    oppgaverHeaderMenu.value
  ])
  const lasterMenyer = ref(<boolean>false)

  async function hentMenyer() {
    lasterMenyer.value = true
    // No need to manually set menus.value since it's now computed
    lasterMenyer.value = false
  }

  return {
    lasterMenyer,
    skrivebordMenuItem,
    ungdommerHeaderMenu,
    ungdomGrupperHeaderMenu,
    notaterHeaderMenu,
    oppgaverHeaderMenu,
    profilHeaderMenu,
    menus,
    hentMenyer
  }
})
